import { cn } from "../../../lib/utils";
import { lpConfig } from "../lpConfig";
import { useFadeIn } from "../useFadeIn";

const steps = lpConfig.solution.steps.map(step => ({
  ...step,
  image: `${process.env.PUBLIC_URL}/images/lp/${step.image}`,
}));

/**
 * ランディングページのソリューション概要セクション
 * 3ステップのフローでStrixSearchの利用手順を視覚的に説明する
 * @return {JSX.Element} ソリューションセクションコンポーネント
 */
export function LpSolution() {
  const fade = useFadeIn();

  return (
    <section className="py-24 lg:py-32 bg-gradient-to-b from-gray-50 to-white">
      <div
        ref={fade.ref}
        className={cn(
          "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 lp-fade-in-up",
          fade.isVisible && "lp-visible",
        )}
      >
        <div className="text-center mb-16">
          <span className="text-xs font-bold tracking-widest text-[#1667CF] uppercase mb-4 block">
            {lpConfig.solution.sectionLabel}
          </span>
          <h2 className="text-4xl font-bold text-[#0F1649]">
            {lpConfig.solution.heading}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {steps.map(step => (
            <div key={step.number}>
              <div className="w-12 h-12 rounded-full bg-[#02072F] text-white font-bold text-lg flex items-center justify-center mx-auto mb-6">
                {step.number}
              </div>
              <div className="rounded-2xl border border-gray-100 bg-gray-50/50 overflow-hidden">
                <div className="aspect-[16/9] overflow-hidden">
                  <img
                    src={step.image}
                    alt={step.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6 text-center">
                  <h3 className="text-xl font-bold text-[#0F1649] mb-3">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
